// extracted by mini-css-extract-plugin
export default {"container":"Input_container__ngyzB","input":"Input_input__ec7Id","styles":"Input_styles__r7s8k","inputBox":"Input_inputBox__eOvlj","error":"Input_error__1VWl2"};